// Constant to use in the app
export const lastClickEl = 'lastClickEl';